/**
 * QuestionListHeader
 */
import React from 'react';
var QuestionListHeader = function (_a) {
    var header = _a.header, id = _a.id, children = _a.children;
    return (React.createElement("div", { className: "relative mt-12 mb-6 border-b-2 border-greyLight", "data-cid": "QuestionListHeader" },
        React.createElement("span", { className: "flex text-black questionlist__header-wrapper" },
            React.createElement("h2", { className: "my-4 text-h2 font-semibold", id: id }, header)),
        React.createElement("div", { className: "richtext mb-10" }, children)));
};
export default QuestionListHeader;
